<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="mchap0" id="b1"><b>ALSO IN THIS SERIES</b></p>
<br/>
<p class="mcenter0">The Death Miser</p>
<p class="mcenter0">Redhead</p>
<p class="mcenter0">First Came a Murder</p>
<p class="mcenter0">Death Round the Corner</p>
<p class="mcenter0">The Mark of the Crescent</p>
<p class="mcenter0">Thunder in Europe</p>
<p class="mcenter0">The Terror Trap</p>
<p class="mcenter0">Carriers of Death</p>
<p class="mcenter0">Days of Danger</p>
<p class="mcenter0">Death Stands By</p>
<p class="mcenter0">Menace</p>
<p class="mcenter0">Murder Must Wait</p>
<p class="mcenter0">Panic!</p>
<p class="mcenter0">Death by Night</p>
<p class="mcenter0">The Island of Peril</p>
<p class="mcenter0">Sabotage</p>
<p class="mcenter0">Go Away Death</p>
<p class="mcenter0">The Day of Disaster</p>
<p class="mcenter0">Prepare for Action</p>
<p class="mcenter0">No Darker Crime</p>
<p class="mcenter0">Dark Peril</p>
<p class="mcenter0">The Peril Ahead</p>
<p class="mcenter0">The League of Dark Men</p>
<p class="mcenter0">The Department of Death</p>
<p class="mcenter0">The Enemy Within</p>
<p class="mcenter0">Dead or Alive</p>
<p class="mcenter0">A Kind of Prisoner</p>
<p class="mcenter0">The Black Spiders</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// back00x.vue?2e083a18